import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";

const DateCell = ({ value, onChange, rowId, field }) => {
  const [startDate, setStartDate] = useState("");

  // Initialize date from the `value` prop if it's valid
  useEffect(() => {
    if (value) {
      // Ensure the date is in a valid format (YYYY-MM-DD)
      const parsedDate = new Date(value);
      if (!isNaN(parsedDate)) {
        const formattedDate = parsedDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD
        setStartDate(formattedDate);
      }
    }
  }, [value]);

  const handleDateChange = (e) => {
    const newDate = e.target.value; // Get the date in the format YYYY-MM-DD
    setStartDate(newDate); // Update local state
    onChange(rowId, newDate, field); // Pass the new date to the parent
  };

  return (
    <div>
      {" "}
      <TextField
        type="date"
        fullWidth
        value={startDate || ""} // Display the start date or an empty string
        onChange={handleDateChange}
        variant="outlined"
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          width: "80px",
          height: "56px",
          borderRadius: "12px",
          background: "#FFFFFF",
          boxShadow: "2px 2px 5px -1px #00000040 inset",
        }}
      />
      <p style={{ fontSize: "10px", margin: 0 }}>{startDate || ""}</p>
    </div>
  );
};

export default DateCell;
